import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { UpsertBroadcastModal } from "~pages/Fixtures/BroadcastPage/components/UpsertBroadcastModal.tsx";
import type { BroadcastTableRow } from "~pages/Fixtures/BroadcastPage/types/broadcastTableRow.ts";
import type { Broadcast } from "~types/broadcast.ts";

type Props = {
  editableRow: number | null;
  row: BroadcastTableRow;
  loading: boolean;
  onSave: () => Promise<void>;
};
export const EditBroadcastAction = ({ editableRow, row, onSave, loading }: Props) => {
  const [currentlyOpenedBroadcastId, setCurrentlyOpenedBroadcastId] = useState<number | null>(null);

  const { formatMessage } = useIntl();

  const handleSave = async (data: Broadcast) => {
    row.broadcaster = data.broadcaster;
    row.broadcastType = data.broadcastType;
    row.broadcastURL = data.broadcastURL;
    row.broadcasterURL = data.broadcasterURL;
    row.broadcastTimezone = data.broadcastTimezone;
    row.locale = data.locale;
    row.startTimeLocal = data.startTimeLocal;
    await onSave();
    setCurrentlyOpenedBroadcastId(null);
  };

  return (
    <>
      {currentlyOpenedBroadcastId === row.id && (
        <UpsertBroadcastModal
          isOpen={currentlyOpenedBroadcastId !== null && currentlyOpenedBroadcastId >= 0}
          onCancel={() => setCurrentlyOpenedBroadcastId(null)}
          loading={loading}
          onOk={handleSave}
          broadcast={row}
        />
      )}
      <Button
        onClick={() => setCurrentlyOpenedBroadcastId(row.id)}
        type={"text"}
        size={"small"}
        disabled={editableRow !== null && editableRow !== row.id}
        title={formatMessage({ id: "table.column.actions.modalEdit" })}
        icon={<i className="fas fa-pen-to-square" />}
      />
    </>
  );
};
